import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import uuid from 'uuid/v1';
import {
	Card,
	CardHeader,
	CardContent,
	CardActions,
	Divider,
	Button,
	Grid,
	TextField,
	Checkbox,
	Autocomplete
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import moment from 'moment';
import { Page, Header, Alert } from 'components';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { TopOffendersAggCityForm } from './components';
import { SetFormState } from '../actions/TopOffendersAggCityActions';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	sitelist: {
		marginTop: theme.spacing(6)
	}
}));

const TopOffendersAggCity = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const sites = useSelector(state => state.TopOffendersAggCityReducer.sites);
	const selectedSites = useSelector(
		state => state.reportsReducer.selectedSites
	);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.TopOffendersAggCityReducer.formState);

	useEffect(() => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				regions: '',
				startDate: null,
				endDate: null
			},
			touched: {
				...formState.touched,
				Site: false
			}
		});
	}, []);

	return (
		<Page className={classes.root} title="Top Offenders">
			<Header module="Top Offenders" view="City Week Agg Report" />
			<TopOffendersAggCityForm />
		</Page>
	);
};

export default TopOffendersAggCity;
